import { isSmoothingWindow, type SmoothingWindow } from '@/features/analysis/utils/smoothing';

export function parseSmoothingParam(searchParams: URLSearchParams): SmoothingWindow {
  const raw = searchParams.get('smoothing');
  return raw && isSmoothingWindow(raw) ? raw : 'off';
}
